import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy } from '@angular/core';
import { fadeInAnimation, fadeOutAnimation, zoomInAnimation, zoomOutAnimation } from 'angular-animations';
import { SharedService } from '../../services/shared.service';
import { VeNewsFeed } from '../../typings';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-qr-code-video',
  templateUrl: './qr-code-video.component.html',
  styleUrl: './qr-code-video.component.scss',
  standalone: false,
  animations: [
    fadeInAnimation(),
    fadeOutAnimation(),
    zoomInAnimation(),
    zoomOutAnimation(),
    trigger('fadeZoom', [
      state('in', style({
        opacity: 1, transform: 'scale(1)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.8)'
      })),
      transition('in <=> out', [
        animate('500ms')
      ])
    ])
  ]
})
export class QrCodeVideoComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  currentNews: any;
  animationStateIn = false;
  qrCodeSize = 140;
  mobileUrl: string;
  private initialAnimationTimeoutId?: number;

 constructor(private sharedService: SharedService) {
    this.sharedService.getConfiguration()
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => {
        this.mobileUrl = config.mobileUrl;
      });
    this.sharedService.videoEnded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(video => {
        this.animationStateIn = false;
      });
  }

  public setInitialValue(v: VeNewsFeed) {
    this.qrCodeSize = document.documentElement.clientWidth / 100 * 8;
    this.currentNews = v;

    this.initialAnimationTimeoutId = window.setTimeout(() => {
      this.animationStateIn = true;
    }, (1000));
  }
  
  public getUrl(url:string):string
  {
    return this.mobileUrl + "home" + url;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.initialAnimationTimeoutId) {
      clearTimeout(this.initialAnimationTimeoutId);
    }
  }
}
